const KB_ALLOWED_ROLES = ["trainer", "admin", "owner", "dev", "platform_admin", "platform_dev", "platform_trainer"] as const;
const KB_PUBLISH_ROLES = ["admin", "owner", "dev", "platform_admin", "platform_dev"] as const;

type HasRoleFn = (...roles: string[]) => boolean;

type Params = {
  hasSession: boolean;
  hasRole: HasRoleFn;
  hasLegacyAdminToken: boolean;
};

export function resolveKbAccess({
  hasSession,
  hasRole,
  hasLegacyAdminToken,
}: Params) {
  const hasRoleAccess = hasSession && KB_ALLOWED_ROLES.some((role) => hasRole(role));
  const canPublishKb = hasLegacyAdminToken || (hasSession && KB_PUBLISH_ROLES.some((role) => hasRole(role)));
  const canManageAppScope = hasLegacyAdminToken || (hasSession && hasRole("platform_admin", "platform_dev"));
  const canManageManufacturerScope =
    canManageAppScope ||
    (hasSession && hasRole("owner", "admin", "dev", "org_owner", "org_admin"));
  const canUseQuickChunkAudit =
    hasLegacyAdminToken ||
    (hasSession &&
      hasRole("admin", "owner", "trainer", "platform_admin", "platform_dev", "platform_trainer"));
  const showDevRescopePill = hasSession && hasRole("platform_dev");
  const hasKbAccess = hasLegacyAdminToken || hasRoleAccess;
  const defaultWriteScope: "app" | "manufacturer" | "org" = canManageManufacturerScope ? "manufacturer" : "org";

  return {
    hasRoleAccess,
    canPublishKb,
    canManageAppScope,
    canManageManufacturerScope,
    canUseQuickChunkAudit,
    showDevRescopePill,
    hasKbAccess,
    defaultWriteScope,
  };
}
